<form [formGroup]="filtersForm" class="grid align-items-end row-gap-1 mt-2">
  <div class="col-12 lg:col-4 flex-order-1 lg:flex-order-0">
    <span class="font-bold block mb-2">Interval căutare</span>
    <p-calendar
      styleClass="w-full"
      dateFormat="dd/mm/yy"
      selectionMode="range"
      formControlName="interval"
      [showIcon]="true"
      [showOnFocus]="true"
      [placeholder]="'Data de la'"
      [panelStyle]="{
        'height': '439px'
      }"
    ></p-calendar>
  </div>

  <div class="col-12 lg:col-4 flex-order-2 lg:flex-order-1">
    <span class="font-bold block mb-1">Lockere</span>
    <p-multiSelect
      formControlName="lockers"
      optionLabel="name"
      optionValue="id"
      placeholder="Filtrează lockere"
      styleClass="w-full"
      appendTo="body"
      filterBy="id,name"
      [options]="lockers()"
      [loading]="!lockers()"
    >
      <ng-template let-locker pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>
            <small class="text-gray-400">#{{ locker?.id }}</small>
            <p class="m-0">{{ locker?.name }}</p>
          </div>
        </div>
      </ng-template>
    </p-multiSelect>
  </div>

  <div class="
    col-12 flex-order-0
    lg:flex-order-2 lg:col-4
    text-right
  ">
    <p-button
      label="Generează raport"
      icon="pi pi-file-plus"
      (onClick)="generateReport()"
    ></p-button>
  </div>
</form>

<p-table
  styleClass="p-datatable-sm"
  currentPageReportTemplate="{first} - {last} din {totalRecords} rapoarte"
  paginatorPosition="both"
  [totalRecords]="totalCount()"
  [lazy]="true"
  [paginator]="true"
  [rows]="filtersForm.get('pageSize')?.value"
  [value]="data()"
  [rowsPerPageOptions]="[25, 50, 100]"
  [showCurrentPageReport]="true"
  (onPage)="pageChanged($event)"
>
  <!-- Outer Table Header (Lockers) -->
  <ng-template pTemplate="header">
    @if (loading()) {
      <tr>
        <td colspan="8">
          <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
        </td>
      </tr>
    }
    <tr>
      <th style="width: 3rem;"></th> <!-- Column for locker expand toggle -->
      <th>Locker</th>
    </tr>
  </ng-template>

  <!-- Outer Table Body: Locker Rows Grouped by Date -->
  <ng-template pTemplate="body" let-group let-rowIndex="rowIndex">
    <!-- Group Header Row (optional if grouping by date) -->
    <tr>
      <td colspan="3" [ngClass]="{'opacity-40': group.items.length === 0}">
        <b>{{ group.date | date: 'dd MMMM yyyy' }}</b>
        @if (group.items.length === 0) {
          <span> - fară activitate</span>
        }
      </td>
    </tr>

    @for (report of group.items; track $index) {
      <ng-container>
        <!-- Locker Row -->
        <tr>
          <td>
            @if (report?.locker) {
              <button
                type="button"
                pButton
                pRipple
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="isLockerExpanded(report) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                (click)="toggleLockerExpansion(report)"
              ></button>
            }
          </td>
          <td>
            @if (report?.locker) {
              @let locker = report.locker;
              <small class="text-gray-400">#{{ locker.identifier }}</small><br>
              <b>{{ locker.name }}</b><br>
              <small>{{ lockerCleanAddress(report.locker.addressParts) }}</small>
            } @else {
              <b class="text-gray-400">-</b>
            }
          </td>
        </tr>

        <!-- Expanded Locker Row: Shipments Table -->
        @if (isLockerExpanded(report)) {
        <tr>
          <td colspan="3">
            <div class="p-3">
              <p-table
                styleClass="p-datatable-sm"
                [value]="report.shipments"
                dataKey="details.request.responseId"
              >
                <!-- Shipments Table Header -->
                <ng-template pTemplate="header">
                  <tr>
                    <th>AWB</th>
                    <th class="text-center">Plasată în locker la</th>
                    <th class="text-center">Ridicată din locker la</th>
                    <th class="text-center">Recuperată din locker la</th>
                    <th class="text-center">Timp in locker</th>
                  </tr>
                </ng-template>

                <!-- Shipments Table Body -->
                <ng-template pTemplate="body" let-shipment let-shipmentIndex="rowIndex">
                  <tr
                    [ngClass]="{
                      'bg-blue-100': getShipmentAction(shipment.actions, 'COURIER_PUT_ORDERS'),
                      'bg-green-100': getShipmentAction(shipment.actions, 'USER_PICK_UP'),
                      'bg-yellow-50': getShipmentAction(shipment.actions, 'COURIER_RETRIEVE_EXPIRED')
                    }"
                    class="cursor-pointer hover:surface-100 transition-colors transition-duration-100"
                    (click)="openRequestDetails(shipment)"
                  >
                    <td>{{ shipment.details.request.awb }}</td>
                    <td class="text-center">{{ getShipmentAction(shipment.actions, "COURIER_PUT_ORDERS")?.occurredAt | date: "dd/MM/YYYY HH:mm" }}</td>
                    <td class="text-center">{{ getShipmentAction(shipment.actions, "USER_PICK_UP")?.occurredAt | date: "dd/MM/YYYY HH:mm" }}</td>
                    <td class="text-center">{{ getShipmentAction(shipment.actions, "COURIER_RETRIEVE_EXPIRED")?.occurredAt | date: "dd/MM/YYYY HH:mm" }}</td>
                    <td class="text-center">{{ formatTimeInLocker(shipment.timeInLocker) }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
        }
      </ng-container>
    }
  </ng-template>

  <!-- Empty Message Template -->
  <ng-template pTemplate="emptymessage">
    @if (!loading()) {
      <tr>
        <td colspan="3">
          <p class="text-center text-gray-400 text-xl font-bold">Nu există rapoarte</p>
        </td>
      </tr>
    }
  </ng-template>
</p-table>
